<template>
  <section class="section">
    <div class="container">
      <div class="page-head">
        <div>
          <h1 class="page-title">Miembros</h1>
          <p class="page-sub">
            Gestiona los integrantes de la congregación
            <span class="leyenda-censo">
              <b-icon icon="star" size="is-small" class="estrella-verde"></b-icon> Censado
              <b-icon icon="star" size="is-small" class="estrella-roja"></b-icon> Sin censar
            </span>
          </p>
        </div>
        <div class="page-actions">
          <b-button type="is-primary" icon-left="plus" @click="abrirNuevo">Agregar miembro</b-button>
        </div>
      </div>

      <div class="toolbar-panel">
        <p class="toolbar-label">Filtros</p>
        <b-field grouped>
          <b-input placeholder="Buscar miembro por nombre" v-model="filtro" @input="buscar" icon="magnify" expanded></b-input>
          <b-select v-if="mostrarGrupo" v-model="filtroGrupo" placeholder="Todos los grupos">
            <option :value="null">Todos los grupos</option>
            <option v-for="g in gruposOrdenados" :value="g.id" :key="g.id">{{ g.nombre }}</option>
          </b-select>
        </b-field>
      </div>

      <div class="stat-cards">
        <div class="stat-card tint-violet">
          <div class="stat-label">Total miembros</div>
          <div class="stat-value">{{ miembros.length }}</div>
          <div class="stat-caption">{{ mostrarGrupo ? 'En todos los grupos' : 'Del grupo activo' }}</div>
        </div>
        <div class="stat-card tint-blue">
          <div class="stat-label">Mostrando</div>
          <div class="stat-value">{{ miembrosVisibles.length }}</div>
          <div class="stat-caption">Resultados con los filtros actuales</div>
        </div>
      </div>

      <div class="table-card">
      <b-table :data="miembrosVisibles" :paginated="true" :per-page="10">
        <b-table-column field="nombre" label="Nombre y apellido" v-slot="props">
          <b-icon icon="star" size="is-small" :class="props.row.familiaId ? 'estrella-verde' : 'estrella-roja'" :title="props.row.familiaId ? 'Censado' : 'Sin censar'"></b-icon>
          {{ props.row.nombre }} {{ props.row.apellido }}
        </b-table-column>

        <b-table-column v-if="mostrarGrupo" field="grupoId" label="Grupo" v-slot="props">
          <span class="tag" :style="estiloGrupo(props.row.grupoId)">{{ nombreGrupo(props.row.grupoId) }}</span>
        </b-table-column>

        <b-table-column field="familiaId" label="Familia" v-slot="props">
          <span v-if="props.row.familia_nombre" class="tag is-primary">{{ etiquetaFamilia(props.row) }}</span>
          <span v-else class="tag is-danger">POR ASIGNAR</span>
        </b-table-column>

        <b-table-column field="telefono" label="Teléfono" v-slot="props">
          {{ props.row.telefono }}
        </b-table-column>

        <b-table-column field="edad" label="Edad" v-slot="props">
          {{ props.row.edad }}
        </b-table-column>

        <b-table-column field="direccion" label="Dirección" centered v-slot="props">
          {{ props.row.direccion || '—' }}
        </b-table-column>

        <b-table-column label="Acciones" width="160" v-slot="props">
          <b-button size="is-small" type="is-info is-light" icon-left="pencil" @click="editar(props.row)">Editar</b-button>
          <b-button size="is-small" type="is-danger is-light" icon-left="delete" @click="confirmarEliminar(props.row.id)">Eliminar</b-button>
        </b-table-column>
      </b-table>
      </div>

      <b-modal :active.sync="mostrarModal" :width="720">
        <div class="box">
          <h3 class="title">{{ editando ? 'Editar miembro' : 'Agregar miembro' }}</h3>
          <b-field v-if="esSuper" label="Grupo">
            <b-select v-model="form.grupoId" placeholder="Seleccione grupo" expanded>
              <option v-for="g in grupos" :value="g.id" :key="g.id">{{ g.nombre }}</option>
            </b-select>
          </b-field>
          <form-miembro
            :miembro="form"
            :foto="fotoMiembro"
            :mostrar-select-familia="true"
            :familias="familiasDelFormulario"
            :mostrar-notas="false"
            :categoria-defecto="categoriaDefecto"
            :categoria-bloqueada="!esSuper"
            @guardar="guardar"
            @cancelar="cerrarModal"
          ></form-miembro>
        </div>
      </b-modal>
    </div>
  </section>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import FormMiembro, { formMiembroVacio } from '../Censo/FormMiembro'

export default {
  name: 'MiembrosComponent',
  components: { FormMiembro },
  data(){
    return {
      miembros: [],
      filtro: '',
      mostrarModal: false,
      editando: false,
      grupos: [],
      familias: [],
      fotoMiembro: null,
      miGrupoId: null,
      miGrupoNombre: '',
      form: formMiembroVacio(),
      cargando: false,
      mostrarGrupo: false,
      filtroGrupo: null
    }
  },
  computed: {
    esSuper(){
      try{ return JSON.parse(localStorage.getItem('roles')||'[]').some(r=> r && r.nombre && r.nombre.toUpperCase()==='SUPER') }catch(e){return false}
    },
    gruposOrdenados(){
      return [...this.grupos].sort((a, b) => String(a.nombre || '').localeCompare(String(b.nombre || ''), 'es'))
    },
    // el miembro puede pertenecer a una familia de cualquier grupo del censo
    familiasDelFormulario(){
      return this.familias
    },
    categoriaDefecto(){
      return this.nombreDelGrupo(this.form.grupoId || this.miGrupoId)
    },
    miembrosVisibles(){
      let lista = [...this.miembros]
      if(this.mostrarGrupo){
        if(this.filtroGrupo !== null && this.filtroGrupo !== ''){
          lista = lista.filter(m => String(m.grupoId) === String(this.filtroGrupo))
        }
        lista.sort((a, b) => {
          const ga = this.nombreGrupo(a.grupoId)
          const gb = this.nombreGrupo(b.grupoId)
          if(ga !== gb) return ga.localeCompare(gb, 'es')
          return String(a.nombre || '').localeCompare(String(b.nombre || ''), 'es')
        })
      }
      return lista
    }
  },
  mounted(){
    this.cargarMiembros()
    this.cargarFamilias()
    this.cargarMiGrupo()
    if(this.esSuper){
      HttpService.obtenerConConsultas('grupos.php',{ accion: 'obtener' })
      .then(r => { this.grupos = Array.isArray(r) ? r : [] })
    }
    // recargar miembros si el SUPER selecciona otro grupo
    window.addEventListener('grupoSeleccionadoChanged', this.cargarMiembros)
    window.addEventListener('grupoSeleccionadoChanged', this.cargarFamilias)
  },
  beforeDestroy(){
    window.removeEventListener('grupoSeleccionadoChanged', this.cargarMiembros)
    window.removeEventListener('grupoSeleccionadoChanged', this.cargarFamilias)
  },
  methods: {
    etiquetaFamilia(row){
      return [row.familia_apellido, row.familia_nombre].filter(Boolean).join(', ')
    },
    // Resuelve el nombre de un grupo por id: lista cargada (super), contexto propio o localStorage
    nombreDelGrupo(gid){
      if(!gid) return ''
      const g = this.grupos.find(x => String(x.id) === String(gid))
      if(g) return g.nombre
      if(String(gid) === String(this.miGrupoId) && this.miGrupoNombre) return this.miGrupoNombre
      if(String(gid) === String(localStorage.getItem('grupoSeleccionado'))) return localStorage.getItem('grupoSeleccionadoNombre') || ''
      if(String(gid) === String(localStorage.getItem('grupoId'))) return localStorage.getItem('grupoNombre') || ''
      return ''
    },
    cargarMiGrupo(){
      // Para jefes/auxiliares: obtener su grupo (el localStorage puede no tenerlo en sesiones viejas)
      if(this.esSuper){
        const g = localStorage.getItem('grupoSeleccionado')
        if(g){ this.miGrupoId = Number(g); this.miGrupoNombre = localStorage.getItem('grupoSeleccionadoNombre') || '' }
        return
      }
      const guardado = localStorage.getItem('grupoId')
      const nombre = localStorage.getItem('grupoNombre')
      if(guardado && nombre){ this.miGrupoId = Number(guardado); this.miGrupoNombre = nombre; return }
      const sesId = localStorage.getItem('id')
      if(!sesId) return
      HttpService.obtenerConConsultas('usuarios.php', { accion: 'obtener_por_id', id: Number(sesId) })
      .then(u => {
        if(!u || !u.grupoId) return
        this.miGrupoId = u.grupoId
        HttpService.obtenerConConsultas('grupos.php', { accion: 'obtener_por_id', id: u.grupoId })
        .then(g => { if(g && g.nombre) this.miGrupoNombre = g.nombre })
      })
    },
    cargarFamilias(){
      HttpService.obtenerConConsultas('familias.php', { accion: 'obtener' })
      .then(r => { this.familias = Array.isArray(r) ? r : [] })
    },
    nombreGrupo(id){
      const g = this.grupos.find(x => String(x.id) === String(id))
      return g ? g.nombre : 'Sin grupo'
    },
    estiloGrupo(id){
      const palette = ['#7C3AED','#06B6D4','#F59E0B','#EF4444','#10B981','#8B5CF6','#F43F5E']
      const color = palette[(Number(id) || 0) % palette.length]
      return { background: color + '1f', color: color }
    },
    cargarMiembros(){
      this.cargando = true
      this.mostrarGrupo = this.esSuper && !localStorage.getItem('superActuandoComoGrupo')
      const payload = { accion: 'obtener' }
      try{ const g = localStorage.getItem('grupoSeleccionado'); if (localStorage.getItem('superActuandoComoGrupo') && g) payload.grupoSeleccionado = Number(g) }catch(e){ void e }
      HttpService.obtenerConConsultas('miembros.php', payload)
      .then(r => {
        if(Array.isArray(r)) this.miembros = r
        else if(r && r.error){ this.miembros = []; this.$buefy.toast.open({type: 'is-danger', message: r.error}) }
        else this.miembros = []
      })
      .finally(()=> this.cargando = false)
    },
    buscar(){
      if(this.filtro.length < 2){ this.cargarMiembros(); return }
      this.cargando = true
      const payload = { accion: 'obtener_por_nombre', nombre: this.filtro }
      try{ const g = localStorage.getItem('grupoSeleccionado'); if (localStorage.getItem('superActuandoComoGrupo') && g) payload.grupoSeleccionado = Number(g) }catch(e){ void e }
      HttpService.obtenerConConsultas('miembros.php', payload)
      .then(r => {
        if(Array.isArray(r)) this.miembros = r
        else if(r && r.error){ this.miembros = []; this.$buefy.toast.open({type: 'is-danger', message: r.error}) }
        else this.miembros = []
      })
      .finally(()=> this.cargando = false)
    },
    abrirNuevo(){
      this.editando = false
      this.fotoMiembro = null
      this.form = formMiembroVacio()
      try{
        const g = localStorage.getItem('grupoSeleccionado') || localStorage.getItem('grupoId') || this.miGrupoId
        this.form.grupoId = g ? Number(g) : null
      }catch(e){ void e }
      this.mostrarModal = true
    },
    editar(row){
      this.editando = true
      this.fotoMiembro = null
      this.form = Object.assign(formMiembroVacio(), row)
      this.form.es_espiritual = Number(row.es_espiritual) ? 1 : 0
      this.mostrarModal = true
      HttpService.obtenerConConsultas('familias.php', { accion: 'obtener_foto', miembroId: row.id })
      .then(r => { if(r && r.foto) this.fotoMiembro = r.foto })
    },
    cerrarModal(){ this.mostrarModal = false },
    guardar(datos){
      const cliente = Object.assign({}, datos)
      delete cliente.foto; delete cliente.fotoNueva; delete cliente.notas
      // el grupo lo manda el selector del modal (super) o lo fija el backend (jefe/auxiliar)
      cliente.grupoId = this.form.grupoId
      const accion = this.editando ? 'editar' : 'registrar'
      const payload = { accion, cliente }
      if(this.esSuper && cliente.grupoId) payload.grupoId = cliente.grupoId
      try{ const g = localStorage.getItem('grupoSeleccionado'); if (localStorage.getItem('superActuandoComoGrupo') && g) payload.grupoSeleccionado = Number(g) }catch(e){ void e }
      HttpService.registrar('miembros.php', payload)
      .then(r => {
        if(r === false || (r && r.error)){
          this.$buefy.toast.open({ type: 'is-danger', message: 'No se pudo guardar el miembro' })
          return
        }
        const miembroId = cliente.id || (typeof r === 'number' ? r : null)
        const fin = () => { this.cargarMiembros(); this.cerrarModal() }
        if(datos.fotoNueva && datos.foto && miembroId){
          HttpService.registrar('familias.php', { accion: 'guardar_foto', miembroId, foto: datos.foto }).then(fin)
        } else fin()
      })
    },
    confirmarEliminar(id){
      if(!confirm('Eliminar miembro?')) return;
      const payload = { accion: 'eliminar', id }
      try{ const g = localStorage.getItem('grupoSeleccionado'); if (localStorage.getItem('superActuandoComoGrupo') && g) payload.grupoSeleccionado = Number(g) }catch(e){ void e }
      HttpService.eliminar('miembros.php', payload)
      .then(()=> this.cargarMiembros())
    }
  }
}
</script>

<style scoped>
/* estilos mínimos */
.container{padding:0}
.estrella-verde{ color:#22a06b; }
.estrella-roja{ color:#e5484d; }
.estrella-verde, .estrella-roja{ vertical-align: middle; }
td .estrella-verde, td .estrella-roja{ margin-right:.35rem; }
.leyenda-censo{ margin-left:.8rem; font-size:.78rem; color:#64748b; }
.leyenda-censo .icon{ margin:0 .15rem 0 .6rem; }
</style>
